import {
  DEVICES_FILTER_FETCH_STARTED,
  DEVICES_FILTER_FETCH_SUCCEEDED,
  DEVICES_FILTER_FETCH_FAILED,
  DEVICES_FILTER_SET_FILTER,
  DEVICES_FILTER_SELECTED_DATA_FETCH_SUCCEEDED,
  DEVICES_FILTER_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  projects: [],
  devices: [],
  types: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'title',
  pages: 0,
  filter: [],
  selectedFilter: [],
  filterBy: 'title'
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DEVICES_FILTER_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case DEVICES_FILTER_FETCH_SUCCEEDED:
      const { projects, devices } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        projects,
        devices,
        types: [...new Set(devices?.map(el => el.type))],
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case DEVICES_FILTER_FETCH_FAILED:
      return { ...state, status: statuses.failed, devices: [], types: [], error: action.error };
    case DEVICES_FILTER_SET_FILTER:
      return { ...state, filter: action.payload };
    case DEVICES_FILTER_SELECTED_DATA_FETCH_SUCCEEDED:
      return {
        ...state,
        selectedFilter: action.payload
      };
    case DEVICES_FILTER_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
